import { DATA_PCR_LN_MODEL , LOCATE_ENDPOINT_VIEWEACH_KINDLAB , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";

export default {
    namespaced: true,

    state: {
        doneFetching : false,
        buffDatPrepareDat : "",
        buffDatCtDat : "",
        dataPCRSpecLN: Object.assign( {} ,DATA_PCR_LN_MODEL) ,
    },

    getters: {

    },

    mutations: {
        setDoneFetching (state, doneFetching) {
            state.doneFetching = doneFetching
        },

        setDataPCRSpecLN (state, dataPCRSpecLN) {
            state.dataPCRSpecLN = dataPCRSpecLN
        },

        setBuffDatPrepareDat (state, buffDatPrepareDat) {
            state.buffDatPrepareDat = buffDatPrepareDat
        },

        setBuffDatCtDat (state, buffDatCtDat) {
            state.buffDatCtDat = buffDatCtDat
        },

    },

    actions: {
        produceDoneFetching({commit},doneFetching){
            commit('setDoneFetching', doneFetching)
        },

        produceBuffDatPrepareDat({commit},buffDatPrepareDat){
            commit('setBuffDatPrepareDat', buffDatPrepareDat)
        },

        produceBuffDatCtDat({commit},buffDatCtDat){
            commit('setBuffDatCtDat', buffDatCtDat)
        },

        fetchPCROLDDat({commit},datTo) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
            return axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.PCR}`, datTo, getConfigAxios())
                .then(res => {
                    // Decode both buffers before mutating Vuex, so failures preserve current edits.
                    const prepare = res.data.dat_prepare.dat == null ? '' : Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8')
                    const ct = res.data.dat_ct.dat == null ? '' : Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8')
                    commit('setDataPCRSpecLN', res.data)
                    commit('setBuffDatPrepareDat', prepare)
                    commit('setBuffDatCtDat', ct)
                    return res.data
                })
        }

    }
}